export function formatDate(
  timestamp: string,
  locale: string = 'en-US',
  omitHourLeadingZero: boolean = false,
  omitSeconds: boolean = false
): { date: string; time: string } {
  if (!timestamp) {
    return { date: '', time: '' };
  }

  const date = new Date(timestamp);

  // Check for invalid date
  if (isNaN(date.getTime())) {
    return { date: 'Invalid Date', time: 'Invalid Date' };
  }

  return {
    date: new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }).format(date),
    time: new Intl.DateTimeFormat(locale, {
      hour: omitHourLeadingZero ? 'numeric' : '2-digit',
      minute: '2-digit',
      second: omitSeconds ? undefined : '2-digit',
      hour12: true
    }).format(date)
  };
}

export const formatDateV2 = (dt: string) => {  
  const fdt = formatDate(dt, 'en-US', true, true);
  return `${fdt.date}, ${fdt.time}`;
};
